import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeft, Printer, ShoppingCart, Home, Star } from 'lucide-react';
import { api } from '../config/api';

const OrderReceipt = () => {
  const { orderId } = useParams();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOrder = async () => {
      try {
        const res = await api.get(`/orders.php?order_id=${orderId}`);
        if (res.data.success) setOrder(res.data.data);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchOrder();
  }, [orderId]);

  const handlePrint = () => window.print();

  if (loading) {
    return (
      <div style={{ backgroundColor: '#faf8f5', minHeight: '100vh', paddingTop: '100px', paddingBottom: '60px' }}>
        <div className="container"><div style={{ textAlign: 'center', padding: '80px 0', color: '#999' }}><p>Loading receipt...</p></div></div>
      </div>
    );
  }

  if (!order) {
    return (
      <div style={{ backgroundColor: '#faf8f5', minHeight: '100vh', paddingTop: '100px', paddingBottom: '60px' }}>
        <div className="container"><div style={{ textAlign: 'center', padding: '80px 0' }}><p style={{ color: '#999' }}>Receipt not found</p><Link to="/my-orders" className="btn btn-gold">Back to My Orders</Link></div></div>
      </div>
    );
  }

  const subtotal = order.items?.reduce((sum, item) => sum + (Number(item.price) * item.quantity), 0) || 0;

  return (
    <div style={{ backgroundColor: '#faf8f5', minHeight: '100vh', paddingTop: '100px', paddingBottom: '60px' }}>
      <div className="container" style={{ maxWidth: '700px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', flexWrap: 'wrap', gap: '10px' }}>
          <Link to="/my-orders" style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', color: '#666', textDecoration: 'none', fontSize: '0.85rem' }}>
            <ArrowLeft size={16} /> Back to My Orders
          </Link>
          <button onClick={handlePrint} className="btn btn-outline-gold" style={{ padding: '8px 18px', fontSize: '0.85rem', display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
            <Printer size={14} /> Print / Download PDF
          </button>
        </div>

        <div style={{ backgroundColor: '#fff', borderRadius: '16px', padding: '40px', border: '1px solid #EAEDF1', boxShadow: '0 2px 12px rgba(0,0,0,0.05)' }}>
          <div style={{ textAlign: 'center', marginBottom: '32px' }}>
            <h2 style={{ fontFamily: 'Playfair Display, serif', fontSize: '2rem', fontWeight: 700, color: '#1A1A1A', marginBottom: '4px' }}>Syra Food Point</h2>
            <p style={{ color: '#999', fontSize: '0.9rem' }}>Food Point & Grill</p>
            <p style={{ color: '#bbb', fontSize: '0.78rem' }}>Order #{order.order_id} • {new Date(order.order_date).toLocaleString()}</p>
          </div>

          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '12px 0', borderBottom: '1px solid #f0f0f0', fontSize: '0.85rem', color: '#666', flexWrap: 'wrap', gap: '8px' }}>
            <span><strong>Customer:</strong> {order.name || 'Guest'}</span>
            <span><strong>Payment:</strong> {order.payment_method}</span>
            <span><strong>Status:</strong> {order.status}</span>
          </div>

          <div style={{ marginTop: '20px' }}>
            <h4 style={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '0.9rem', color: '#333', marginBottom: '12px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Order Items</h4>
            {order.items?.map((item, i) => (
              <div key={i} style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0', borderBottom: '1px solid #f5f5f5', fontSize: '0.9rem' }}>
                <span style={{ color: '#555' }}>{item.item_name} × <strong>{item.quantity}</strong></span>
                <span style={{ fontWeight: 600, color: '#333' }}>UGX {Number(item.price * item.quantity).toLocaleString()}</span>
              </div>
            ))}
          </div>

          <div style={{ borderTop: '2px solid #1A1A1A', marginTop: '16px', paddingTop: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span style={{ fontWeight: 700, color: '#1A1A1A', fontSize: '1.2rem' }}>Total</span>
            <span style={{ fontWeight: 700, color: '#D4AF37', fontSize: '1.3rem' }}>UGX {Number(order.total_amount).toLocaleString()}</span>
          </div>

          {order.delivery_address && (
            <div style={{ marginTop: '20px', padding: '12px', backgroundColor: '#FAFAFA', borderRadius: '10px', fontSize: '0.85rem', color: '#666' }}>
              <strong>Delivery Address:</strong> {order.delivery_address}
            </div>
          )}

          <div style={{ marginTop: '24px', textAlign: 'center', color: '#bbb', fontSize: '0.75rem' }}>
            Thank you for dining with Syra Food Point! • {new Date().toLocaleDateString()}
          </div>
        </div>

        <div style={{ display: 'flex', gap: '10px', marginTop: '20px', flexWrap: 'wrap' }}>
          <Link to={`/track-order/${order.order_id}`} className="btn btn-outline-gold" style={{ flex: 1, padding: '12px 16px', fontSize: '0.85rem', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '6px' }}>
            <Star size={14} /> Rate Your Experience
          </Link>
          <Link to={`/track-order/${order.order_id}`} className="btn btn-gold" style={{ flex: 1, padding: '12px 16px', fontSize: '0.85rem', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '6px' }}>
            Order Again
          </Link>
        </div>
      </div>

      <style>{`@media print { body { background: #fff } .btn, nav, footer { display: none !important } }`}</style>
    </div>
  );
};

export default OrderReceipt;
